/**
 * ClawInstall compare (`/compare`) — eager half of the route. Registers the
 * file route with its SSR head only; the page component and every design /
 * seam import live in `compare.lazy.tsx` so they load with this route and never
 * land in the always-loaded `main` chunk (the `entryChunkGzipKb` budget,
 * CLA-645). Mounted outside the `/clawinstall` layout (trailing-underscore
 * escape) so the frame's `<main>` is the only main landmark.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { type HeadCtxLike, identityFromHeadCtx, publicPageHead } from "~/lib/clawinstall-marketing-head.ts";

/** SSR head for `/compare`: identity-scoped title/canonical and comparison description. @since 1.0.0 */
export const compareHead = (ctx?: HeadCtxLike) => {
  const identity = identityFromHeadCtx(ctx);
  return publicPageHead({
    path: "/compare",
    title: `Compare — ${identity.displayName}`,
    description:
      `Do it yourself, cheap hosting, a consultancy, or ${identity.displayName}: how the options differ on time, security, backups and what happens when an update breaks it.`,
    identity,
  });
};

export const Route = createFileRoute("/clawinstall_/compare")({
  head: compareHead,
});
